import { render, staticRenderFns } from "./guanf.vue?vue&type=template&id=16cf5dcb&scoped=true"
import script from "./guanf.vue?vue&type=script&lang=js"
export * from "./guanf.vue?vue&type=script&lang=js"
import style0 from "./guanf.vue?vue&type=style&index=0&id=16cf5dcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf5dcb",
  null
  
)

export default component.exports